export class NaicsInformation {
  public code: string;
  public description: string;
}

export class User {
  public companyName: string;
  public emailAddress: string;
  public name: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public policyNumber: string;
  public eErgoTrainingComplete: boolean;
  public naicsInformation: NaicsInformation;
  public insuredName: string;
  public businessSegment: string;

  constructor(
    emailAddress: string,
    name: string,
    firstName: string,
    lastName: string,
    policyNumber: string,
    naicsInformation: NaicsInformation,
    insuredName: string,
    businessSegment: string
  ) {
    this.emailAddress = emailAddress;
    this.name = name;
    this.firstName = firstName;
    this.lastName = lastName;
    this.policyNumber = policyNumber;
    this.naicsInformation = naicsInformation;
    this.insuredName = insuredName;
    this.businessSegment = businessSegment;
  }
}


